import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import ProductShowcase from '../components/ProductShowcase';
import AboutUs from '../components/AboutUs';
import LocalSupport from '../components/LocalSupport';
import Contact from '../components/Contact';

function HomePage() {
  return (
    <>
      <Hero />
      <Features />
      <ProductShowcase />
      <AboutUs />
      <LocalSupport />
      <Contact />
    </>
  );
}

export default HomePage;
